import { render, staticRenderFns } from "./attr_horizontal.vue?vue&type=template&id=13be4140&scoped=true&"
import script from "./attr_horizontal.vue?vue&type=script&lang=js&"
export * from "./attr_horizontal.vue?vue&type=script&lang=js&"
import style0 from "./attr_horizontal.vue?vue&type=style&index=0&id=13be4140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be4140",
  null
  
)

export default component.exports